module.exports = __webpack_public_path__ + "img/MATERIAL.6d1b35e1.png";